// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"30182762","323":"0b608607"}[chunkId] + ".chunk.css";
};